import { useEffect } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { prettyFloatMoney } from '@/helpers/utils';
import { DATE_FORMAT_DD_MM_YYYY } from '@/helpers/common';
import Preloader from '@/components/UI/Preloader';
import { getLoanDetail, getPaymentHistory } from '@/store/actions/loanActions';
import { LoanDetails } from './components/LoanDetails';
import { PaymentSchedule } from './components/PaymentSchedule';
import { FinancingAgreements } from './components/FinancingAgreements';
import { SecurityDeposit } from './components/SecurityDeposit';
import { RepaymentHistory } from './components/RepaymentHistory';
import './index.scss';

const LoanInfo = ({ loan }) => {
  const dispatch = useDispatch();
  const { loanDetail } = useSelector(state => state.loanStore);
  const { amounts } = loan;
  const { data, loading } = loanDetail;
  const { t } = useTranslation('loans');

  useEffect(() => {
    dispatch(getLoanDetail(loan.fundraising_id));
    dispatch(getPaymentHistory(loan.fundraising_id, { page: 1, limit: 100 }));
  }, []);

  return (
    <div className="loan-info">
      {loading ? (
        <Preloader className="loan-info__preloader" />
      ) : (
        <>
          <div className="loan-info-base">
            <h2 className="f-26 f-500">{t('loan_info.loan')}</h2>
            <div className="loan-info-base__table">
              <div className="loan-info-base__thead">
                <div className="loan-info-base__thead-col">{t('loan_info.started')}</div>
                <div className="loan-info-base__thead-col">{t('loan_info.end_date')}</div>
                <div className="loan-info-base__thead-col">{t('loan_info.loan_total')}</div>
                <div className="loan-info-base__thead-col">{t('loan_info.outstanding')}</div>
                <div className="loan-info-base__thead-col">{t('loan_info.fpg_option')}</div>
              </div>
              <div className="loan-info-base__tbody">
                <div className="loan-info-base__tbody-row">
                  <div className="loan-info-base__tbody-col">
                    {data ? moment(data.started).format(DATE_FORMAT_DD_MM_YYYY) : '-'}
                  </div>
                  <div className="loan-info-base__tbody-col">
                    {data ? moment(data.end_of_grace_period).format(DATE_FORMAT_DD_MM_YYYY) : '-'}
                  </div>
                  <div className="loan-info-base__tbody-col">
                    {prettyFloatMoney(amounts.total_loan_amount)}
                  </div>
                  <div className="loan-info-base__tbody-col">
                    {prettyFloatMoney(amounts.outstanding)}
                  </div>
                  <div className="loan-info-base__tbody-col">
                    {loan.selected_fpg ? loan.selected_fpg.title : '-'}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {data && (
            <>
              <LoanDetails loans={data.loans} />
              <PaymentSchedule fundraisingId={loan.fundraising_id} loan={loan} />
              <FinancingAgreements fundraisingId={loan.fundraising_id} data={data} />
              <SecurityDeposit insurance={data.insurance} />
              <RepaymentHistory />
            </>
          )}
        </>
      )}
    </div>
  );
};

export default LoanInfo;
